const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  accountType: state => state.user.accountType,
  supplierType: state => state.user.supplierType,
  phone: state => state.user.phone,
  supplierName: state => state.user.supplierName,
  supplierId: state => state.user.supplierId,
  supplierCode: state => state.user.supplierCode,
  isAuth: state => state.user.isAuth,
  isLink: state => state.user.isLink,
  natureType: state => state.user.natureType,
  userInit: state => state.user.userInit,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  fetchingToken: state => state.app.fetchingToken,
  loginType: state => state.user.loginType
}

export default getters
